'use client'

import { createContext, useState } from 'react'

export type CompleteReservationParam = {
  reservationNo: string
  transactionId: string
  stayReservationId: number
}

interface CompleteReservationContextValue {
  completeReservationParam: CompleteReservationParam | undefined
  setCompleteReservationParam: (
    param: CompleteReservationParam | undefined,
  ) => void
}

export const CompleteReservationContext =
  createContext<CompleteReservationContextValue>({
    completeReservationParam: undefined,
    setCompleteReservationParam: () => {},
  })

const CompleteReservationContextProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [completeReservationParam, setCompleteReservationParam] = useState<
    CompleteReservationParam | undefined
  >(undefined)

  return (
    <CompleteReservationContext.Provider
      value={{
        completeReservationParam,
        setCompleteReservationParam,
      }}
    >
      {children}
    </CompleteReservationContext.Provider>
  )
}

export default CompleteReservationContextProvider
